export const menu = [
  {
    title: "Home",
    to: "/",
  },
  {
    title: "Skills",
    to: "/skills",
  },
  {
    title: "Jobs",
    to: "/jobs",
  },
  {
    title: "Contact",
    to: "/contact",
  },
];
